<template>
    <div class="modal modal-edit fade" id="editPaymentModal" tabindex="-1" role="dialog" aria-labelledby="editPaymentModal" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
        <form action="ohyesedit" method="POST" @submit.prevent="updatePayment()">
            <div class="modal-content">
                <div class="modal-header bg-system">
                    <strong class="modal-title text-white">Edit Payment</strong>
                    <button type="button" class="close" @click="closeModal()">
                        <span class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h5 class="text-danger">Exchange Rate : $ {{ exchangeRate.usd }} = {{ exchangeRate.khr }}</h5>
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="mb-1">
                                <label for="paymentMethod" class="form-group">Payment Methods</label>
                                <select id="ecategory_id" class="form-control" data-live-search="false">
                                    <option value="">PLEASE SELECT ONE</option>
                                    <option :value="method.id" v-for="method in paymentMethod" :key="method.id">{{ method.name }}</option>
                                </select>
                            </div>
                            <div class="mb-1">
                                <label for="amountEditPayment">Amount</label>
                                <div class="input-group">
                                    <input 
                                        id="amountEditPayment"
                                        type="number" 
                                        min="0" 
                                        :max="totalUsd" 
                                        step="0.001"
                                        class="form-control"
                                    >
                                    <div class="input-group-append">
                                        <label class="input-group-text bg-system text-white">$</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="mb-1">
                                <label for="photo" class="form-group">Payment Image</label>
                                <div class="w-100">
                                    <input id="photo" @change="changeImg('photo',$event)" type="file" class="form-control">
                                    <button type="button" @click="resetImg('photo')" v-if="pho" title="Reset Photo" class="border-0 rounded outline-0 float-right btn-outline-dark"><i class="fas fa-redo-alt"></i></button>
                                    <img v-if="phoo" :src="photo" class="my-2 w-25 rounded">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button :disabled="isUpdate" type="submit" class="btn btn-system btn-xs">
                        <img v-if="isUpdate" src="@/assets/sniper.jpeg" alt="" width="12">
                        <i v-else class="fa fa-save"></i> Update
                    </button>
                    <button @click="closeModal()" type="button" class="btn btn-danger btn-xs">
                        <i class="fa fa-times"></i> Close
                    </button>
                </div>
            </div>
        </form>
        </div>
    </div>  
</template> 
<script>
import { resource } from '@/networks/domain'
import axios from 'axios';
import { updatePayment } from '@/networks/services/pos/invoicePos.service';

export default {
    emits : ["updatePayment"],
    props : {
        totalUsd: {
            type: [String, Number],
            default: 0,
        },
        paymentMethod : {
            type : [Object,Array],
            default : []
        },
        invoiceId : {
            type : [Number, String],
            default : 0
        },
        exchangeRate : {
            type : [Object, Array],
            default : {}
        },
        paymentId : {
            type : [String, Number],
            default : 0
        },
        eMethodId : {
            type : [String, Number],
            default : 0
        }
    },
    computed : {
        amount(){
            return this.amountEdit;
        }
    },
    data(){
        return {
            resource : resource,
            isUpdate : false,
            method_id : '',
            photo : '',
            pho: false,
            phoo: null,
        }
    },
    methods: {
        closeModal(){
            $('#editPaymentModal').modal('hide');
        },
        resetImg(value){
            if(value == "photo"){
                this.photo = '';
                this.pho = false;
                this.phoo = null;
                $('#photo').val('');
            }
        },
        changeImg(value,obj){
            if(value == "photo"){
                this.photo = URL.createObjectURL(obj.target.files[0]);
                this.phoo = obj.target.files[0];
                this.pho = true;
            }
        },
        async updatePayment(){
            if($('#amountEditPayment').val() == ''){
                alertify.set('notifier','position', 'top-right');
                alertify.error('Amount is require');
            } else if($('#ecategory_id').val() == ''){
                alertify.set('notifier','position', 'top-right');
                alertify.error("Payment Method is require !");
            } else {
                this.isUpdate = true;
                let amount_khr = Number($('#amountEditPayment').val()) * Number(this.exchangeRate.khr);

                var data = new FormData();
                data.append('photo',this.photo);
                data.append('invoice_id',this.invoiceId);
                data.append('id',this.paymentId);
                data.append('payment_method_id',$("#ecategory_id").val());
                data.append('payment_method_name',this.paymentMethod.filter((item)=>item.id == $("#ecategory_id").val())[0].name);
                data.append('amount_usd',$('#amountEditPayment').val());
                data.append('amount_khr',Number(amount_khr).toFixed(2));
                data.append('exchange_rate_khr',this.exchangeRate.khr);
                data.append('exchange_rate_usd', this.exchangeRate.usd);

                await axios.post(updatePayment,data)
                .then((res)=>{
                    if(res.data.status == 'success'){
                        this.closeModal();
                        // alertify.set('notifier','position', 'top-right');
                        // alertify.success(`${res.data.message}`);
                        this.$emit("updatePayment","success");   
                    }else if(res.data.status == "401"){
                        alertify.set('notifier','position', 'top-right');
                        alertify.success(`${res.data.message}`);
                        localStorage.removeItem('posUser');
                        this.$router.push('/Unauthenticated');
                    } 
                    else if(res.data.status == "is_permission_no"){
                        this.closeModal();
                        alertify.set('notifier','position', 'top-right');
                        alertify.error(`${res.data.message}`);
                        this.$emit("updatePayment","is_permission_no");   
                    } 
                    else if(res.data.status == "error"){
                        alertify.set('notifier','position', 'top-right');
                        alertify.error(`${res.data.message}`); 
                    } else {
                        console.log(res)
                    } 
                })
                .catch((err)=>{
                    console.log(err);
                })
                this.isUpdate = false;
            }
        }
    },
}
</script>
<style scoped>
.modal-edit {
  position: absolute;
  float: left;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>